import { EventData, EventSnapshot } from '../api/types';

/**
 * Returns the correct display name for an event.
 * If the event has a built-in `name` (e.g., outrights), it returns that.
 * Otherwise, it constructs the name using `${home} - ${away}`.
 */
export function getEventName(data: EventData | EventSnapshot | any): string {
  if (!data) return '';
  
  // If a snapshot is passed, extract the event data
  const eventData: EventData = data.event && data.scope ? data.event : data;
  
  if (eventData?.name) {
    return eventData.name;
  }
  const homeName = eventData?.home?.name || '';
  const awayName = eventData?.away?.name || '';

  if (homeName && awayName) {
    return `${homeName} - ${awayName}`;
  } else if (homeName) {
    return homeName;
  } else if (awayName) {
    return awayName;
  }
  return '';
}
